import type { TPredikatOrganisasiStatus } from 'types/kinerja-pelaksanaan'

export const PREDIKAT_ORGANISASI_STATUS_LABELS: Record<
  TPredikatOrganisasiStatus,
  string
> = {
  NOT_SENT: 'Belum selesai dinilai oleh Kepala Sekolah',
  READY_TO_SEND: 'Siap dikirim',
  SENT: 'Sudah dikirim',
  DINAS_UNCONFIRMED: 'Kepala Sekolah belum konfirmasi data atasan',
  DINAS_REJECTED: 'Kepala Sekolah konfirmasi Anda bukan atasannya',
}
